// import Image from "/assets/testimonials/client3.jpg"
import client1 from "../../assets/client.jpg";
import client2 from "../../assets/client1.png";
import client3 from "../../assets/client2.jpg";
import client4 from "../../assets/client4.png";
import client5 from "../../assets/client5.png";

export const data = [
  {
    id: 1,
    image: client1,
    name: "Customer opinion",
    rating: 5,
  },
  {
    id: 2,
    image: client2,
    name: "Customer opinion",
    rating: 5,
  },
  {
    id: 3,
    image: client3,
    name: "Customer opinion",
    rating: 5,
  },
  {
    id: 4,
    image: client4,
    name: "Customer opinion",
    rating: 5,
  },
    {
    id: 5,
    image: client5,
    name: "Customer opinion",
    rating: 5,
  }
];



// import Image1 from '../../assets/boy1testimonial.png'
// import Image2 from '../../assets/boy2testimonial.png'
// import Image3 from '../../assets/girl1testimonial.png'


// export const data = [
//     {
//       id: 1,
//       image: Image1,
//       name: "Atia Alaa",
//       description:
//       "I had the pleasure of working with Soufiane Amama on a web development project. He was extremely patient with me throughout the process, and was always willing to take my opinions and modify the project to my specifications."
//       ,
//     },
//     {
//       id: 2,
//       image: Image2,
//       name: "Ahmed Al-Wakeel",
//       description:
//         "Excellent customer service I recently worked with Soufiane Amama on a web development project and I was extremely impressed with his work.",
//     },
//     {
//       id: 3,
//       image: Image3,
//       name: "Sara Hesham",
//       description:
//       "He provided excellent post production support and ensured that the website was good and responsive. He was always available to answer any questions I had and provided helpful advice throughout the project. I highly recommend Soufiane Amama for any web development project.",
//     },
//   ];
  
